/* filter data for shipment */


export const namespaced = true

export const state = {
    agent_id_list:[],
    line_id_list :[],
    status_list :[],
    filter_date_from : "",
    filter_date_to : "",
    filter_count:0,
}

export const mutations = {
    SET_DISPATCH_SHIPMET_FILTER(state, {
        agent_id_list,
        line_id_list,
        status_list,
        filter_date_from,
        filter_date_to,
        filter_count,
    }) {
        state.agent_id_list = agent_id_list
        state.line_id_list = line_id_list
        state.status_list = status_list
        state.filter_date_from = filter_date_from
        state.filter_date_to = filter_date_to
        state.filter_count = filter_count
    },
}
export const actions = {
    setDispatchShipmentFilter({
        commit
    }, items) {
        commit('SET_DISPATCH_SHIPMET_FILTER', items)
    },
}
export const getters = {
    getDispatchShipmentFilter: state => {
        return state;
    },
}